import { PrescriberContactData } from './../model/requests-model';
import {
  CommonDataDTO,
  EstablishmentByUserDTO,
  EstablishmentDTO,
  ModalityPaymentDTO,
  FormPaymentDTO,
  SectorDTO,
  CallTariffDTO,
  FinancialProduct,
  PostalCodeDTO,
  TariffDTO,
  ComboDTO,
  VehicleTypeFuel,
  CountryDTO,
  ComercialProductResponseDTO,
  VendorComboDTO,
} from '../model/combos-model';
import { Injectable } from '@angular/core';

import { CombosApi } from './combos-api.service';
import { BehaviorSubject } from 'rxjs';
import { AgentDTO } from '../model/requests-model';
import {
  ANULADAS,
  APROBADAS,
  CONDICIONADA_PENDIENTE_DE_FORMALIZACION,
  DENEGADAS,
  EN_ESTUDIO,
  FIRMADAS,
  FORMALIZADAS_ABONADAS_VALIDADAS,
  INPUT_CHANNEL_FORM,
  INPUT_CHANNEL_TELEPHONE,
  LANGUAGE_CATALAN,
  LANGUAGE_SPANISH,
  PENDIENTES_DE_DATOS,
  PENDIENTES_PAGO_POR_INCIDENCIAS,
  REQUEST_PAID_PENDING_VALIDATION,
} from '@app/@core/constants/requests.constants';
import { RequestDataAutosService } from '../@shared/request-data-autos/request-data-autos.service';
import { CommercialDTO } from '@app/payment-for-certifications/model/payment-model';

@Injectable()
export class CombosStore {
  private languageRequest: string;
  private brandRequest: string;

  private employmentSituationList = new BehaviorSubject<CommonDataDTO[]>([]);
  public employmentSituationList$ = this.employmentSituationList.asObservable();

  private sectorBusinessList = new BehaviorSubject<CommonDataDTO[]>([]);
  public sectorBusinessList$ = this.sectorBusinessList.asObservable();

  private cnaeList = new BehaviorSubject<CommonDataDTO[]>([]);
  public cnaeList$ = this.cnaeList.asObservable();

  private originsRevenueList = new BehaviorSubject<CommonDataDTO[]>([]);
  public originsRevenueList$ = this.originsRevenueList.asObservable();

  private residentialSituationList = new BehaviorSubject<CommonDataDTO[]>([]);
  public residentialSituationList$ = this.residentialSituationList.asObservable();

  private countryList = new BehaviorSubject<CommonDataDTO[]>([]);
  public countryList$ = this.countryList.asObservable();

  private civilStatusList = new BehaviorSubject<CommonDataDTO[]>([]);
  public civilStatusList$ = this.civilStatusList.asObservable();

  private relationHolderList = new BehaviorSubject<CommonDataDTO[]>([]);
  public relationHolderList$ = this.relationHolderList.asObservable();

  private ownershipList = new BehaviorSubject<CommonDataDTO[]>([]);
  public ownershipList$ = this.ownershipList.asObservable();

  public modalityPaymentList = new BehaviorSubject<CommonDataDTO[]>([]);
  public modalityPaymentList$ = this.modalityPaymentList.asObservable();

  private statusRequestsList = new BehaviorSubject<CommonDataDTO[]>([]);
  public statusRequestsList$ = this.statusRequestsList.asObservable();

  public languages: any[] = [
    { id: LANGUAGE_SPANISH, value: 'pointOfSale.language.ES' },
    { id: LANGUAGE_CATALAN, value: 'pointOfSale.language.CAT' },
  ];

  public inputChannels: any[] = [{ id: INPUT_CHANNEL_TELEPHONE, value: 'pointOfSale.inputChannel.phone' }];
  public inputChannelsMG: any[] = [
    { id: INPUT_CHANNEL_TELEPHONE, value: 'pointOfSale.inputChannel.phone' },
    { id: INPUT_CHANNEL_FORM, value: 'pointOfSale.inputChannel.form' },
  ];

  public employeeMGData: any[] = [
    { id: true, value: 'pointOfSale.employeeMG.yes' },
    { id: false, value: 'pointOfSale.employeeMG.no' },
  ];

  //Importante: no cambiar los ids, son los valores que se tienen que enviar
  public fixedFeeList: CommonDataDTO[] = [
    { id: '20', value: '20' },
    { id: '50', value: '50' },
    { id: '90', value: '90' },
    { id: '120', value: '120' },
    { id: 'Other', value: 'requestDataCard.selectCustomAmount' },
  ];

  public genderList: any[] = [
    { id: 'H', value: 'holderData.genderMale' },
    { id: 'M', value: 'holderData.genderFemale' },
  ];

  public numPersonInChargeList: any[] = [
    { id: '00', value: 'socioeconomicData.peopleInChargeZero' },
    { id: '01', value: 'socioeconomicData.peopleInChargeOne' },
    { id: '02', value: 'socioeconomicData.peopleInChargeTwo' },
    { id: '03', value: 'socioeconomicData.peopleInChargeThree' },
    { id: '04', value: 'socioeconomicData.peopleInChargeFour' },
    { id: '05', value: 'socioeconomicData.peopleInChargeFive' },
  ];

  public monthsList: CommonDataDTO[] = [
    { id: '1', value: 'requestData.january' },
    { id: '2', value: 'requestData.february' },
    { id: '3', value: 'requestData.march' },
    { id: '4', value: 'requestData.april' },
    { id: '5', value: 'requestData.may' },
    { id: '6', value: 'requestData.june' },
    { id: '7', value: 'requestData.july' },
    { id: '8', value: 'requestData.august' },
    { id: '9', value: 'requestData.september' },
    { id: '10', value: 'requestData.october' },
    { id: '11', value: 'requestData.november' },
    { id: '12', value: 'requestData.december' },
  ];

  public insuranceValues: CommonDataDTO[] = [
    { id: 'N', value: 'NO' },
    { id: 'S', value: 'SÍ' },
  ];

  public holderAccountList: CommonDataDTO[] = [
    { id: 'A', value: 'intervininentData.typeGuarantor' },
    { id: 'C', value: 'intervininentData.typeCotitular' },
  ];

  public affirmativeNegativeList: CommonDataDTO[] = [
    { id: 'SI', value: 'SI' },
    { id: 'NO', value: 'NO' },
  ];

  constructor(private combosApi: CombosApi, private combosAutosApi: RequestDataAutosService) {
    this.languageRequest = 'ES';
  }

  getMonthsList() {
    let monthsList: string[] = [];
    for (let i = 1; i <= 10; i++) {
      let total = 6 * i;
      monthsList.push(total.toString());
    }
    return monthsList;
  }

  public setLanguageRequest(language: string) {
    console.log('idioma seteado: ', language);
    this.languageRequest = language;
    this.loadCommonCombos().catch((error) => console.log(error));
    if (this.languageRequest && this.brandRequest) {
      this.loadModalityPayment(this.brandRequest, this.languageRequest);
    }
  }

  public setBrandRequest(brand: string) {
    this.brandRequest = brand;
  }

  private loadCommonCombos(): Promise<any> {
    console.log('cargando combos, idioma: ', this.languageRequest);
    return new Promise<void>((resolve, reject) => {
      this.combosApi
        .getCommonCombos({
          language: this.languageRequest,
        })
        .toPromise()
        .then(
          (data) => {
            if (data) {
              let dataList: CommonDataDTO[] = [];
              let countrySpain: CountryDTO[] = [];
              let countryList: CountryDTO[] = [];

              data.employmentSituation.forEach((employmentSituation) =>
                dataList.push({ id: employmentSituation.id, value: employmentSituation.value.toUpperCase() })
              );
              this.employmentSituationList.next(dataList);

              if (data.cnae) {
                dataList = [];
                data.cnae.forEach((cnae) => dataList.push({ id: cnae.id, value: cnae.value.toUpperCase() }));
                this.cnaeList.next(dataList);
              }

              dataList = [];
              data.originsRevenues.forEach((originsRevenue) =>
                dataList.push({ id: originsRevenue.id, value: originsRevenue.value.toUpperCase() })
              );
              this.originsRevenueList.next(dataList);

              dataList = [];
              data.residentialSituation.forEach((residentialSituation) =>
                dataList.push({ id: residentialSituation.id, value: residentialSituation.value.toUpperCase() })
              );
              this.residentialSituationList.next(dataList);

              countryList = [];
              data.country.forEach((country) => {
                if (country.id == 'ES') {
                  countrySpain.push({
                    id: country.id,
                    value: country.value,
                    operationRestricted: country.operationRestricted,
                  });
                } else {
                  countryList.push({
                    id: country.id,
                    value: country.value,
                    operationRestricted: country.operationRestricted,
                  });
                }
              });
              this.countryList.next(countrySpain.concat(countryList));

              dataList = [];
              data.civilStatus.forEach((civilStatus) =>
                dataList.push({ id: civilStatus.id, value: civilStatus.value.toUpperCase() })
              );
              this.civilStatusList.next(dataList);

              dataList = [];
              data.relationHolder.forEach((relationHolder) =>
                dataList.push({ id: relationHolder.id, value: relationHolder.value.toUpperCase() })
              );
              this.relationHolderList.next(dataList);

              dataList = [];
              data.holderAccount.forEach((ownership) => {
                if (ownership.id !== null) {
                  dataList.push({ id: ownership.id, value: ownership.value.toUpperCase() });
                }
              });
              this.ownershipList.next(dataList);

              resolve();
            } else reject();
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
    });
  }

  public loadComboTowns(postalCode: string): Promise<CommonDataDTO[]> {
    return new Promise<CommonDataDTO[]>((resolve, reject) => {
      let postalCodeDto: PostalCodeDTO;

      postalCodeDto = {
        language: this.languageRequest,
        postalCode: postalCode,
      };

      this.combosApi
        .getTownsList(postalCodeDto)
        .toPromise()
        .then(
          (data) => (data ? resolve(data) : reject(data)),
          (error) => {
            console.log(error);
            reject(error);
          }
        );
    });
  }

  public loadComboTariffs(establishment: string, commercialProduct: string, lineProduct: string): Promise<TariffDTO[]> {
    return new Promise<TariffDTO[]>((resolve, reject) => {
      const callTariff: CallTariffDTO = {
        establishment: establishment,
        commercialProduct: commercialProduct,
        lineProduct: lineProduct,
      };

      this.combosApi
        .getTariffs(callTariff)
        .toPromise()
        .then(
          (data) => (data ? resolve(data) : reject(data)),
          (error) => {
            console.log(error);
            reject(error);
          }
        );
    });
  }

  public ComercialProductResponseToCommonData(respuestaFork: ComercialProductResponseDTO[]): CommonDataDTO[] {
    console.log(respuestaFork);
    let comercialProductList: CommonDataDTO[] = [];
    respuestaFork.forEach((element) => {
      console.log(element);
      let comercialProduct: CommonDataDTO = {
        id: element.id,
        value: element.description,
      };
      console.log(comercialProduct);
      comercialProductList.push(comercialProduct);
    });
    return comercialProductList;
  }

  public loadCommercialProduct(
    establishment: string,
    operative: string,
    amount?: any
  ): Promise<ComercialProductResponseDTO[]> {
    return new Promise<ComercialProductResponseDTO[]>((resolve, reject) => {
      const establishmentDTO: EstablishmentDTO = {
        establishment: establishment,
        operative: operative,
        amountFinance: amount,
      };
      this.combosApi
        .getCommercialProduct(establishmentDTO)
        .toPromise()
        .then(
          (data) => {
            let commercialProductList: ComercialProductResponseDTO[] = [];
            if (data) {
              data.forEach((commercialProduct) =>
                commercialProductList.push({
                  id: commercialProduct.id,
                  description: commercialProduct.description.toUpperCase(),
                  maxAmount: commercialProduct.maxAmount,
                })
              );
              resolve(commercialProductList);
            } else reject(commercialProductList);
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
    });
  }

  public loadCommercialProductForCombos(
    establishment: string,
    operative: string,
    amount?: any
  ): Promise<ComercialProductResponseDTO[]> {
    return new Promise<ComercialProductResponseDTO[]>((resolve, reject) => {
      const establishmentDTO: EstablishmentDTO = {
        establishment: establishment,
        operative: operative,
        amountFinance: amount,
      };
      this.combosApi
        .getCommercialProductForCombos(establishmentDTO)
        .toPromise()
        .then(
          (data) => {
            let commercialProductList: ComercialProductResponseDTO[] = [];
            if (data) {
              data.forEach((commercialProduct) =>
                commercialProductList.push({
                  id: commercialProduct.id,
                  description: commercialProduct.description.toUpperCase(),
                  maxAmount: commercialProduct.maxAmount,
                })
              );
              resolve(commercialProductList);
            } else reject(commercialProductList);
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
    });
  }

  public loadLineProduct(establishment: string): Promise<CommonDataDTO[]> {
    return new Promise<CommonDataDTO[]>((resolve, reject) => {
      const establishmentDTO: EstablishmentByUserDTO = { user: establishment };
      this.combosApi
        .getLineProduct(establishmentDTO)
        .toPromise()
        .then(
          (data) => {
            let lineProductList: CommonDataDTO[] = [];
            if (data) {
              data.forEach((lineProduct) =>
                lineProductList.push({ id: lineProduct.id, value: lineProduct.value.toUpperCase() })
              );
              resolve(lineProductList);
            } else reject(lineProductList);
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
    });
  }

  public loadExpirationDays(product: number): Promise<CommonDataDTO[]> {
    return new Promise<CommonDataDTO[]>((resolve, reject) => {
      let financialProduct: FinancialProduct = { financialProduct: product };
      this.combosApi
        .getExpirationDays(financialProduct)
        .toPromise()
        .then(
          (data) => {
            let expirationDaysList: CommonDataDTO[] = [];
            if (data) {
              data.forEach((expirationDay) =>
                expirationDaysList.push({ id: expirationDay.id, value: expirationDay.value.toUpperCase() })
              );
              resolve(expirationDaysList);
            } else reject(expirationDaysList);
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
    });
  }

  public loadProduct(lineProduct: string): Promise<CommonDataDTO[]> {
    return new Promise<CommonDataDTO[]>((resolve, reject) => {
      let sector: SectorDTO = { sector: lineProduct, language: 'ES' };
      this.combosApi
        .getProduct(sector)
        .toPromise()
        .then(
          (data) => {
            let productList: CommonDataDTO[] = [];
            if (data) {
              data.forEach((product) => productList.push({ id: product.id, value: product.value.toUpperCase() }));
              resolve(productList);
            } else reject(productList);
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
    });
  }

  public loadModalityPayment(brand: string, language: string): Promise<CommonDataDTO[]> {
    return new Promise<CommonDataDTO[]>((resolve, reject) => {
      let modalityPayment: ModalityPaymentDTO = { brand: brand, language: language };
      this.combosApi
        .getModalityPayment(modalityPayment)
        .toPromise()
        .then(
          (data) => {
            let modalityPaymentList: CommonDataDTO[] = [];
            if (data) {
              data.forEach((modalityPayment) =>
                modalityPaymentList.push({ id: modalityPayment.id, value: modalityPayment.value.toUpperCase() })
              );
              this.modalityPaymentList.next(modalityPaymentList);
              resolve(modalityPaymentList);
            } else reject(modalityPaymentList);
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
    });
  }

  //Load formPayment
  public loadFormPayment(financialProduct: string, comercialProduct: string): Promise<CommonDataDTO[]> {
    return new Promise<CommonDataDTO[]>((resolve, reject) => {
      let formPayment: FormPaymentDTO = { financialProduct: financialProduct, commercialProduct: comercialProduct };
      this.combosApi
        .getFormPayment(formPayment)
        .toPromise()
        .then(
          (data) => {
            let formPaymentList: CommonDataDTO[] = [];
            if (data) {
              data.forEach((formPayment) =>
                formPaymentList.push({ id: formPayment.id, value: formPayment.value.toUpperCase() })
              );
              resolve(formPaymentList);
            } else reject(formPaymentList);
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
    });
  }

  public loadStatusRequests(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.combosApi
        .getStatusRequests()
        .toPromise()
        .then(
          (data) => {
            if (data) {
              const response = data
                .filter((status) => status.id !== REQUEST_PAID_PENDING_VALIDATION)
                .map((status) => this.setRequestsStatus(status.id));
              this.statusRequestsList.next(response);
              resolve();
            } else reject(data);
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
    });
  }

  public getDivisions(): Promise<CommonDataDTO[]> {
    return new Promise<CommonDataDTO[]>((resolve, reject) => {
      this.combosApi
        .getDivisions()
        .toPromise()
        .then(
          (data) => resolve(data),
          (error) => reject(error)
        );
    });
  }

  public getOffices(filter?: any): Promise<CommonDataDTO[]> {
    return new Promise<CommonDataDTO[]>((resolve, reject) => {
      this.combosApi
        .getOffices(filter ? filter : {})
        .toPromise()
        .then(
          (data) => resolve(data),
          (error) => reject(error)
        );
    });
  }

  public getChains(filter?: any): Promise<CommonDataDTO[]> {
    return new Promise<CommonDataDTO[]>((resolve, reject) => {
      this.combosApi
        .getChains(filter ? filter : {})
        .toPromise()
        .then(
          (data) => resolve(data),
          (error) => reject(error)
        );
    });
  }

  public getPrescribers(filter?: any): Promise<CommonDataDTO[]> {
    return new Promise<CommonDataDTO[]>((resolve, reject) => {
      this.combosApi
        .getPrescribers(filter ? filter : {})
        .toPromise()
        .then(
          (data) => resolve(data),
          (error) => reject(error)
        );
    });
  }

  public getEstablishments(filter?: any): Promise<CommonDataDTO[]> {
    return new Promise<CommonDataDTO[]>((resolve, reject) => {
      this.combosApi
        .getEstablishments(filter ? filter : {})
        .toPromise()
        .then(
          (data) => resolve(data),
          (error) => reject(error)
        );
    });
  }

  public getEstablishmentsByPrescribers(request: any): Promise<CommonDataDTO[]> {
    return new Promise<CommonDataDTO[]>((resolve, reject) => {
      this.combosApi
        .getEstablishmentsByPrescribers(request)
        .toPromise()
        .then(
          (data) => resolve(data),
          (error) => reject(error)
        );
    });
  }

  getPrescribersByChains(request: any): Promise<CommonDataDTO[]> {
    return new Promise<CommonDataDTO[]>((resolve, reject) => {
      this.combosApi
        .getPrescribersByChains(request)
        .toPromise()
        .then(
          (data) => resolve(data),
          (error) => reject(error)
        );
    });
  }

  public getUserById(userId: string): Promise<CommonDataDTO> {
    return new Promise<CommonDataDTO>((resolve, reject) => {
      this.combosApi
        .getUserById(userId)
        .toPromise()
        .then(
          (data) => resolve(data),
          (error) => reject(error)
        );
    });
  }

  public loadVendors(establishment: string): Promise<VendorComboDTO[]> {
    return new Promise<VendorComboDTO[]>((resolve, reject) => {
      this.combosApi
        .getVendor(establishment)
        .toPromise()
        .then(
          (data) => resolve(data),
          (error) => reject(error)
        );
    });
  }

  public loadEmploymentSituation(sitLaboral: string): Promise<any> {
    const comboDTO: ComboDTO = { language: this.languageRequest, filter: sitLaboral };
    return new Promise<CommonDataDTO[]>((resolve, reject) => {
      this.combosApi
        .getEmploymentSituation(comboDTO)
        .toPromise()
        .then(
          (data) => (data ? resolve(data) : reject(data)),
          (error) => reject(error)
        );
    });
  }

  public loadSectorBusiness(job: string): Promise<any> {
    const comboDTO: ComboDTO = { language: this.languageRequest, filter: job };
    return new Promise<CommonDataDTO[]>((resolve, reject) => {
      this.combosApi
        .getSectorBusiness(comboDTO)
        .toPromise()
        .then(
          (data) => (data ? resolve(data) : reject(data)),
          (error) => reject(error)
        );
    });
  }

  public loadCnae(enterpriseActivity: string): Promise<any> {
    const comboDTO: ComboDTO = { language: this.languageRequest, filter: enterpriseActivity };
    return new Promise<CommonDataDTO[]>((resolve, reject) => {
      this.combosApi
        .getCnae(comboDTO)
        .toPromise()
        .then(
          (data) => (data ? resolve(data) : reject(data)),
          (error) => reject(error)
        );
    });
  }

  public loadPrescriberData(): Promise<PrescriberContactData> {
    return new Promise<PrescriberContactData>((resolve, reject) => {
      this.combosApi
        .getPrescriberData()
        .toPromise()
        .then(
          (data: any) => (data ? resolve(data) : reject(data)),
          (error: any) => reject(error)
        );
    });
  }

  getChainsFromMacroUser(user: string): Promise<CommonDataDTO[]> {
    return new Promise<CommonDataDTO[]>((resolve, reject) => {
      this.combosApi
        .getChainsFromMacroUser(user)
        .toPromise()
        .then((data) => (data ? resolve(data) : reject(data)))
        .catch((error) => console.error(error));
    });
  }

  getOfficesFromMacroUser(user: string): Promise<CommonDataDTO[]> {
    return new Promise<CommonDataDTO[]>((resolve, reject) => {
      this.combosApi
        .getOfficesByMacroUser(user)
        .toPromise()
        .then((data) => (data ? resolve(data) : reject(data)))
        .catch((error) => console.error(error));
    });
  }

  getChainsByDivision(division: string): Promise<CommonDataDTO[]> {
    return new Promise<CommonDataDTO[]>((resolve, reject) => {
      this.combosApi
        .getAllChainsByDivision(division)
        .toPromise()
        .then((data) => (data ? resolve(data) : reject(data)))
        .catch((error) => console.error(error));
    });
  }

  getOfficesByDivision(division: string): Promise<CommonDataDTO[]> {
    return new Promise<CommonDataDTO[]>((resolve, reject) => {
      this.combosApi
        .getAllOfficesByDivision(division)
        .toPromise()
        .then((data) => (data ? resolve(data) : reject(data)))
        .catch((error) => console.error(error));
    });
  }
  private setRequestsStatus = (filterID: string): CommonDataDTO => {
    let statusName = '';
    switch (filterID) {
      case PENDIENTES_DE_DATOS:
        statusName = 'request.search.status.pending';
        break;
      case APROBADAS:
        statusName = 'request.search.status.approve';
        break;
      case EN_ESTUDIO:
        statusName = 'request.search.status.study';
        break;
      case DENEGADAS:
        statusName = 'request.search.status.denied';
        break;
      case FORMALIZADAS_ABONADAS_VALIDADAS:
        statusName = 'request.search.status.formalise';
        break;
      case ANULADAS:
        statusName = 'request.search.status.cancel';
        break;
      case PENDIENTES_PAGO_POR_INCIDENCIAS:
        statusName = 'request.search.status.pending.bug';
        break;
      case FIRMADAS:
        statusName = 'request.search.status.signed';
        break;
      case CONDICIONADA_PENDIENTE_DE_FORMALIZACION:
        statusName = 'request.search.status.conditioned.pending';
        break;
      default:
        console.error('Status not defined in the application');
    }
    return { id: filterID, value: statusName };
  };

  getFuelType(fuelTypeRequest: VehicleTypeFuel): Promise<CommonDataDTO[]> {
    return new Promise<CommonDataDTO[]>((resolve, reject) => {
      this.combosAutosApi
        .getFuelType(fuelTypeRequest)
        .toPromise()
        .then((data) => (data ? resolve(data) : reject(data)))
        .catch((error) => console.error(error));
    });
  }

  public getEstablishmentWithCertifiedPaymentByExternalCommercial(filter?: CommercialDTO): Promise<CommonDataDTO[]> {
    return new Promise<CommonDataDTO[]>((resolve, reject) => {
      this.combosApi
        .getEstablishmentsWithCertifiedPaymentsByExternalCommercial(filter)
        .toPromise()
        .then(
          (data) => resolve(data),
          (error) => reject(error)
        );
    });
  }
}
